import { useState} from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse, Button } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaMapMarkerAlt, FaDrawPolygon} from 'react-icons/fa';
import uuid from 'react-uuid';
import './Outline.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OutlineItmes = ({ outline, handleItemHighlight, handleItemPopup, handleItemDeletePopup }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const OutlineList = outline.outlineList;

    const CustomToastWithLink = () => (
        <div>
            <p>This container will have at least a farm boundary and the Map Centre. Click on edit if you wish to change either of these.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
        <Row>
            <Col>
                <Card>
                    <CardHeader className="item-header item_click" onClick={toggle}>
                        <Row>
                            <Col sm="11">
                                <h5 className="color-dark-teal">Outline items</h5>
                            </Col>
                            <Col sm="1" style={{marginLeft:"auto",marginRight:"5px"}} className="toggleoutline">
                                {isIconUp ? <FaChevronUp /> : <FaChevronDown />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={isOpen}>
                        <CardBody>
                            {
                                <Row>
                                    <Col>
                                        <table className="table borderless">
                                            <thead></thead>
                                            <tbody>
                                                <tr className="" key={uuid()}>
                                                    <td >
                                                        <Table className='table borderless '>
                                                            <thead >
                                                                <tr>
                                                                    <th style={{ width: '10%' }}> </th>
                                                                    <th style={{ width: '70%' }}> Item Name </th>
                                                                    <th style={{ width: '10%' }}> </th>
                                                                    <th style={{ width: '10%' }}> </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    OutlineList.map(item =>

                                                                        <tr key={item.id}>
                                                                            <td>
                                                                                <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                                                                    {item.mapType == 'marker' ? <FaMapMarkerAlt color={"Red"}></FaMapMarkerAlt> :
                                                                                        item.mapType == 'polygon' && <FaDrawPolygon color={"Red"}></FaDrawPolygon>}
                                                                                </a>
                                                                            </td>
                                                                            <td> {item.name} </td>
                                                                            <td>
                                                                                <Button color="warning" size="sm" onClick={(itemId) => handleItemPopup(item.itemId)}>Edit</Button>
                                                                            </td>
                                                                            <td>
                                                                                {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') && item.mapType != 'marker' &&
                                                                                    <>
                                                                                    <Button color="danger" size="sm" onClick={(itemId) => handleItemDeletePopup(item.itemId)}>Delete</Button>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                            </tbody>
                                                        </Table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            }
                        </CardBody>
                    </Collapse>
                </Card>
            </Col>
        </Row>
    );

}
export default OutlineItmes;